goog.provide("shadow.js.shim.module$$mui$material$ToggleButtonGroup$default");
shadow.js.shim.module$$mui$material$ToggleButtonGroup$default = shadow.js.shim.module$$mui$material$ToggleButtonGroup.default;
